export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const cut = (str: string, len: number = str.length) => {
  return `${str.slice(0, len).trim()}${str.length > len ? '...' : ''}`;
};
